<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 md10 lg6>
        <barcode
          title="Receiving"
          subtitle="Scan or Enter a Serial Number"
          buttonText="Search Stock"
          @search="searchStock"
          @cleared="handleCleared"
          :extraButtonText="
            viewTransfers ? 'Hide Transfer History' : 'View Transfer History'
          "
          @extraAction="viewTransfers = !viewTransfers"
          ref="barcodeComponent"
        />
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 md10 lg6>
        <v-card color="primary" :style="{ width: '100%', margin: 'auto' }">
          <v-data-table
            v-if="viewTransfers"
            :headers="headers"
            :items="recentTransfers.bindle"
            :pagination.sync="pagination"
            class="elevation-1 mt-2"
            :total-items="recentTransfers.total_count"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">
                  {{ props.item.product_id[1] }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.location_dest_id[1] }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.create_date }}
                </td>
                <td class="text-xs-left">
                  <v-btn
                    flat
                    icon
                    @click="
                      props.expanded = !props.expanded;
                      getRowDetails(props.expanded, props.item.id);
                    "
                  >
                    <v-icon>fa-expand</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expand="">
              <v-card flat color="primary">
                <div style="border: 1px solid white;">
                  <v-card-text>
                    <h3>Serials:</h3>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text v-for="(move, index) in moveLines" :key="index">
                    {{ `${index + 1}. ` }}{{ move.lot_id[1] }}
                  </v-card-text>
                </div>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      transition="dialog-transition"
      @keydown="validateLocation"
      persistent
    >
      <v-card
        :color="locationScanned ? 'success' : 'primary'"
        style="height: 600px; text-align: center; overflow: scroll"
        class="scrollbar-hide"
      >
        <v-layout row>
          <v-flex xs6 class="mt-3">
            <h3 v-if="currentProduct[0]">
              <span>SKU:</span>
              <h3 class="mb-4">
                {{
                  currentProduct[0].product_id[1]
                }}
              </h3>
            </h3>
            <v-card-text>
              <h3>Total Count:</h3>
              <h1>{{ filteredSerials.length }}</h1>
              <div
                style="height: 220px; overflow: scroll;"
                class="scrollbar-hide"
              >
                <v-combobox
                  @change="$forceUpdate()"
                  color="success"
                  chips
                  deletable-chips
                  label="Scan the Serials"
                  multiple
                  v-model="enteredSerials"
                  ref="serialField"
                />
              </div>
            </v-card-text>
          </v-flex>
          <v-flex xs6 class="mt-3 scrollbar-hide">
            <h3 v-if="recommendLocation.length">
              Recommended
              {{ recommendLocation.length > 1 ? "Locations:" : "Location:" }}
              <div
                class="mx-2 scrollbar-hide"
                style="height: 400px; overflow: scroll;"
              >
                <div
                  v-for="(location, index) in recommendLocation"
                  :key="index"
                >
                  <h1>{{ location }}</h1>
                </div>
              </div>
            </h3>
            <h1 v-else>No Recommended Location</h1>
            <div
              v-if="!recommendLocation.length"
              class="mx-2 scrollbar-hide"
              style="height: 400px; overflow: scroll"
            ></div>
          </v-flex>
        </v-layout>
        <v-card-text style="text-align: center">
          <h1>
            {{
              locationScanned
                ? `Scan Location Again to Move to ${enteredLocation}`
                : "Scan a Location"
            }}
          </h1>
        </v-card-text>
        <v-card-actions style="position: absolute; bottom: 0; width: 100%">
          <div class="mx-auto">
            <v-btn @click="dialog = false">Cancel</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="productDialog"
      :width="dialogWidth"
      transition="dialog-transition"
      persistent
    >
      <v-card
        color="primary"
        style="height: 440px; text-align: center"
        class="scrollbar-hide"
      >
        <h1>Found Multiple Matches!</h1>
        <h3>Please Select the correct product</h3>
        <div v-for="(item, index) in currentProduct" :key="index">
          <v-btn
            @click="searchStock(false, item.id)"
            style="width: 80%;overflow: hidden;"
          >
            <span style="width: 80%;overflow: hidden;text-overflow: ellipsis;">
              {{ item.product_id[1] }}
            </span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="errorDialog"
      :width="dialogWidth"
      transition="dialog-transition"
      persistent
      ><v-card
        class="scrollbar-hide"
        color="primary"
        style="height: 500px; text-align: center;overflow: scroll"
      >
        <h1>The following errors occured:</h1>
        <h4 class="mb-4">(All other serials have been moved)</h4>
        <ul class="text-align: left">
          <li v-for="(item, index) in moveErrors" :key="index">
            <span>{{ item }}</span>
          </li>
        </ul>
        <v-card-actions style="position: absolute; bottom: 0; width: 100%">
          <div class="mx-auto">
            <v-btn @click="exitError()">Close</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Barcode from "@/components/app/Barcode";

export default {
  name: "receiving-barcode",
  data() {
    return {
      recommendLocation: [],
      dialog: false,
      productDialog: false,
      enteredLocation: "",
      enteredSerials: [],
      scanner: "",
      confirmed: false,
      currentProduct: false,
      scanCount: 0,
      viewTransfers: false,
      headers: [
        { text: "Transfer", value: "name" },
        { text: "Product", value: "product_id[1]" },
        { text: "Destination Location", value: "location_dest_id[1]" },
        { text: "Date Created", value: "create_date" },
        { text: "Expand Row", value: "create_date", sortable: false }
      ],
      pagination: {
        rowsPerPage: 5,
        sortBy: "create_date",
        descending: true,
        page: 1
      },
      expand: false,
      moveErrors: [],
      errorDialog: false,
      alreadyMoved: false,
      dropship: false
    };
  },

  components: {
    Barcode
  },

  mixins: [LoginCheck],

  watch: {
    dialog(val) {
      if (!val) this.handleCleared();
      if (val) this.alreadyMoved = false;
    },
    scanner(val) {
      const regex = new RegExp(/(\d\d \d\d \d\d)/);
      if (val.match(regex)) {
        this.enteredLocation = val.match(regex)[0];
        this.confirmed = true;
        this.scanCount += 1;
        this.scanner = "";
      } else if (val.endsWith("Tab") || val.endsWith("Enter")) {
        this.confirmed = false;
        this.scanner = "";
      }
    },
    viewTransfers(val) {
      if (val) {
        this.getTransfers({ limit: 5, offset: 0 });
      }
    },

    pagination(val) {
      if (this.viewTransfers) {
        if (val.rowsPerPage < 0)
          val.rowsPerPage = this.recentTransfers.total_count;
        this.getTransfers({
          limit: val.rowsPerPage,
          offset: val.rowsPerPage * (val.page - 1)
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      recentTransfers: "receiving/getRecentTransfers",
      moveLines: "stockMoveLine/getMoveLine"
    }),
    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        return "80%";
      } else return "70%";
    },

    locationScanned() {
      const regex = new RegExp(/(\d\d \d\d \d\d)/);
      if (this.enteredLocation.match(regex)) {
        return true;
      } else return false;
    },

    filteredSerials() {
      const regex = new RegExp(/(\d\d \d\d \d\d)/);
      return [...new Set(this.enteredSerials)].filter(item => {
        if (!item.match(regex)) {
          return item;
        }
      });
    }
  },

  methods: {
    ...mapActions({
      search: "receiving/search",
      moveProductBulk: "receiving/moveProductBulk",
      getTransfers: "receiving/getRecentTransfers",
      getMoveLines: "stockMoveLine/search",
      syncQty: "receiving/syncQty",
      setLoading: "app/setLoading"
    }),

    async validateLocation(e) {
      this.scanner += e.key;
      if (this.scanCount == 2) {
        const regex = new RegExp(/(\d\d \d\d \d\d)/);
        let filteredSerials = [...new Set(this.enteredSerials)].filter(item => {
          if (!item.match(regex)) {
            return item;
          }
        });

        if (!this.alreadyMoved) {
          let moves = [];
          for (const serial of filteredSerials) {
            moves.push({
              lot_id: serial,
              product_id: this.currentProduct[0].product_id[0],
              dest_location: this.enteredLocation
            });
          }
          const bindle = await this.moveProductBulk({moves});
          await this.handleErrors(bindle, true);
          this.alreadyMoved = true;
        }
      }
    },

    async handleErrors(bindle, lastIndex = false) {
      if (!bindle.success) {
        this.moveErrors.push(...bindle.error);
      }

      if (lastIndex) {
        if (this.moveErrors.length > 0) {
          this.errorDialog = true;
        } else {
          await this.syncQty({
            product_id: this.currentProduct[0].product_id[0]
          });

          this.dialog = false;
          this.handleCleared();
          this.$store.dispatch("app/setSnackbar", {
            text: "Products moved!",
            color: "green"
          });
        }
      }
    },

    async exitError() {
      await this.syncQty({
        product_id: this.currentProduct[0].product_id[0]
      });
      this.errorDialog = false;
      this.dialog = false;
    },

    async searchStock(barcodeValue = false, condition = false) {
      let searchParams = condition
        ? [{ field: "id", operator: "=", value: condition }]
        : [
            { field: "lot_id.name", operator: "=", value: barcodeValue },
            { field: "location_id.usage", operator: "=", value: "internal" },
            {
              field: "location_id.complete_name",
              operator: "like",
              value: "Holding"
            }
          ];
      this.currentProduct = await this.search(searchParams);
      
      if (this.currentProduct.length == 0) {
        searchParams = condition
          ? [{ field: "id", operator: "=", value: condition }]
          : [
              { field: "lot_id.name", operator: "=", value: barcodeValue },
              { field: "location_id.usage", operator: "=", value: "internal" },
              {
                field: "location_id.complete_name",
                operator: "like",
                value: "3PL"
              }
            ];
        this.currentProduct = await this.search(searchParams);
      }

      if (this.currentProduct.length == 0) {
        searchParams = condition
          ? [{ field: "id", operator: "=", value: condition }]
          : [
              { field: "lot_id.name", operator: "=", value: barcodeValue },
              { field: "location_id.usage", operator: "=", value: "internal" },
              {
                field: "location_id.complete_name",
                operator: "like",
                value: "Packaging"
              }
            ];
        this.currentProduct = await this.search(searchParams);
      }

      if (this.currentProduct.length == 0) {
        searchParams = condition
          ? [{ field: "id", operator: "=", value: condition }]
          : [
              { field: "lot_id.name", operator: "=", value: barcodeValue },
              { field: "location_id.usage", operator: "=", value: "internal" },
              {
                field: "location_id.complete_name",
                operator: "like",
                value: "Sellable"
              }
            ];
        this.currentProduct = await this.search(searchParams);
      }


      if (this.currentProduct.length == 1) {
        this.viewTransfers = false;
        const { product_id, owner_id, id } = this.currentProduct[0];
        let ownerIDs = [];
        ownerIDs.push(owner_id[0]);

        if (owner_id[0] == 1) ownerIDs.push(5853);
        else if (owner_id[0] == 5853) ownerIDs.push(1);
        let similarProductsParams = [
          { field: "id", operator: "!=", value: id },
          { field: "product_id.id", operator: "=", value: product_id[0] },
          { field: "owner_id.id", operator: "in", value: ownerIDs },
          { field: "location_id.usage", operator: "=", value: "internal" },
        ];
        
        if (this.currentProduct[0].location_id[0]== 22455) {
          similarProductsParams.push(
            { field: "location_id.location_id", operator: "=", value: 21956 }
          );
        } else {
          similarProductsParams.push(
            { field: "location_id.complete_name",operator: "like",value: "Stock" }
          )
        }

        let similarProducts = await this.search(similarProductsParams);
        similarProducts.forEach(product => {
          let location = product.location_id[1].substring(
            product.location_id[1].lastIndexOf("/") + 1
          );
          if (!this.recommendLocation.includes(location))
            this.recommendLocation.push(location);
        });
        this.productDialog = false;
        this.dialog = true;
        this.enteredSerials.push(this.currentProduct[0].lot_id[1]);
        setTimeout(() => {
          this.$refs.serialField.focus();
        }, 250);
      } else if (this.currentProduct.length > 1) {
        this.productDialog = true;
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "This product is not in an internal location!",
          color: "red"
        });
      }
    },

    async getRowDetails(opened, id) {
      if (opened) {
        await this.getMoveLines([
          { field: "picking_id", operator: "=", value: id }
        ]);
      }
    },

    handleCleared() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$refs.barcodeComponent.focusBarcode();
    }
  }
};
</script>

<style>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
